import React from "react";
import CustomCheckbox from "./style";
import { Checkbox } from "@mui/material";

const Index = ({ label, name, value, onChange, checked }) => {
  return (
    <CustomCheckbox
      control={
        <Checkbox
          //defaultUnChecked
          name={name}
          value={value}
          checked={checked}
          onChange={onChange && onChange}
          // className="subTitle_Th"
          sx={{
            color: "#5E70CC",
            "&.Mui-checked": {
              color: "#5E70CC",
            },
          }}
        />
      }
      label={label}
    />
  );
};

export default Index;
